<template>
    <div>
        <div class="content-header">
            <div>
                <h2 class="content-title card-title">Update Hub</h2>
            </div>
        </div>
        <a-card v-if="hub">
            <a-form :form="form"  @submit="handleSubmit">
                <a-row :gutter="16">
                    <a-col class="gutter-row" :span="12">
                        <a-form-item label="Name">
                            <a-input size="large"
                                v-decorator="['name', { rules: [{ required: true, message: 'Please enter name' }],
                                    initialValue: hub.name }]"
                                placeholder="Enter name"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col class="gutter-row" :span="12">
                        <a-form-item label="Status">
                            <a-select size="large"
                                v-decorator="[
                                'status',
                                { rules: [{ required: true, message: 'Please select Status!' }],
                                    initialValue: hub.status }]"
                                placeholder="Select Status"
                            >
                                <a-select-option :value="1">
                                Active
                                </a-select-option>
                                <a-select-option :value="0">
                                Inactive
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                </a-row>

                <a-row :gutter="16">
                    <a-col class="gutter-row" :span="24">
                        <a-form-item label="Location">
                            <!-- <a-input size="large" disabled
                                v-decorator="['address', { rules: [{ required: true, message: 'Please Enter Coordibates' }],
                                    initialValue: hub.address }]"
                                placeholder="Enter Location"
                            /> -->
                            <!-- @keyup.enter="updateMaker" -->
                            <GmapAutocomplete class="location-address-content" :value="hub.address" ref="gmapAutocomplete"
                                :position.sync="markers[0].position"
                                @place_changed="updateMaker">
                            </GmapAutocomplete>
                        </a-form-item>
                        
                        <div class="py-5 px-5">
                            <gmap-map :center="center" :zoom="15" style="width: 100%; height: 500px">
                                <gmap-marker v-for="(m, i) in markers" :key="i" :position="m.position" 
                                    :clickable="true" :draggable="true" @click="center=m.position"
                                    @drag="updateCoordinates" ></gmap-marker>
                            </gmap-map>
                        </div>
                    </a-col>
                </a-row>

                <a-form-item >
                    <a-button type="primary" class="btn btn-xs" size="large" html-type="submit">
                        Update Hub
                    </a-button>
                </a-form-item>
            </a-form>
        </a-card>
        <a-card v-else>
            <h4>Hub not find</h4>
        </a-card>
    </div>
</template>

<script>
import { HUB_UPDATE, HUB_LIST } from "../../../script/api";
import { postData, getData, getWithoutToken } from "../../../script/api-service";
import {alertPop} from "../../../script/helper";

export default {
    props: ['hubId'],
    data: function() {
        return {
            form: this.$form.createForm(this, { name: 'coordinated' }),
            center: {lat: 23.750, lng: 90.387},
            markers: [{
                position: {
                    lat: 23.750, lng: 90.387
                }
            }],
            coordinates: {},
            hub: '',
            address: ''
        }
    },
    watch: {
        markers: function (val) {
            console.log("val", val);
        },
    },
    methods: {
        async updateCoordinates(location) {
            this.coordinates = {
                lat: location.latLng.lat(),
                lng: location.latLng.lng(),
            };
            let locationAddress = await getWithoutToken(location.latLng.lat(), location.latLng.lng());

            // console.log("location", locationAddress);
            if (locationAddress && locationAddress?.data?.results?.length) {
                let result = locationAddress.data.results[0];
                console.log("result", result);
                this.hub.address = result.formatted_address;
            }
        },
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields( async(err, values) => {
                if (!err) {
                    let data = {};
                    
                    if (this.hub.name !== values.name) data.name = values.name;
                    // if (this.hub.address !== values.address) 
                    data.address = values.address;

                    if (Object.keys(data).length) {
                        // data.company_id = 1;
                        data.latitude = this.coordinates.lat || this.center.lat;
                        data.longitude = this.coordinates.lng || this.center.lng;
                        data.hub_id = this.hubId;
                        data.status = values.status;
                        data.address = this.hub.address;

                        let res = await postData(HUB_UPDATE, data);

                        if (res) {
                            alertPop('success', 'Hub Updated successfully');
                        }
                    } else {
                        alertPop('warning', 'No change found');
                    }
                    
                }
            });
        },
        async getHubs() {
            let res = await getData(HUB_LIST);

            if (res) {
                let masterData = res.data?.data;
                this.hub = masterData.find(e => e.id == this.hubId);

                let position = {
                        lat: this.hub.latitude *1, lng: this.hub.longitude *1
                    };    

                this.markers =  [{
                    position: position
                }];
                this.center = position;
                this.address = this.hub.address;
            }
        },
        updateMaker: function (place) {
            if (place) {

                console.log("place.formatted_address", place.formatted_address);
                this.address = place.formatted_address;
                this.center = {
                    lat: place.geometry.location.lat(),
                    lng: place.geometry.location.lng(),
                }

                this.markers = [{
                    position: this.center
                }]
            }
        }
    },
    mounted() {
        this.getHubs();
    },
}
</script>